const OAUTH_RESERVED_PARAMETERS = ["access_token", "session_state", "state", "iss", "code"]

export { OAUTH_RESERVED_PARAMETERS }
